import { render, staticRenderFns } from "./TheSystemDrawer.vue?vue&type=template&id=6cfcbfcb&"
import script from "./TheSystemDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheSystemDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports